import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { FAQAccess } from '../FAQAccess';
import { Field, useFormState } from 'react-final-form';
import CheckboxField from 'components/CheckboxFieldGroup/CheckboxField';
import QAndAContext from '../../providers/QAndA/QAndA.context';
import ManageFaqText from './components/ManageFaqText';
import { Question } from '../../models/QAndA';

import './AddQuestionToFaq.styles.scss';

type AddQuestionToFaqProps = {
  className?: string;
  question?: Question;
};

const AddQuestionToFaq: React.FC<AddQuestionToFaqProps> = (props) => {
  const { className, question } = props;

  const classes = classNames('add-question-to-faq', className);

  const { t } = useTranslation();

  const {
    values: { publishToFAQ },
  } = useFormState();
  const { canFaq, faqAccessData } = useContext(QAndAContext);

  const canPublishToFAQ = canFaq && !question?.dataRoomParentQuestionId;

  if (!canPublishToFAQ) return null;

  return (
    <div className={classes}>
      <ManageFaqText />

      <FAQAccess showFAQAccess={publishToFAQ} data={faqAccessData}>
        <Field
          name="publishToFAQ"
          label={t('publishThisToFaq')}
          type="checkbox"
          component={CheckboxField}
        />
      </FAQAccess>
    </div>
  );
};

export default AddQuestionToFaq;
